import {
  GET_ORGANIZATION_REQUEST,
  GET_ORGANIZATION_SUCCESS,
  GET_ORGANIZATION_FAILED,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILED,
  GENERATE_API_TOKEN_SUCCESS,
  GENERATE_QC_TOKEN_SUCCESS,
  GENERATE_REPORTS_API_TOKEN_SUCCESS,
} from './actionTypes';

const initialState = {
  organization: null,
  loading: false,
  error: null,
};

const organizationsEditReducer = (state = initialState, {
  type, error, organization,
}) => {
  switch (type) {
    case GET_ORGANIZATION_REQUEST:
      return { ...state, loading: true, organization: null };
    case GET_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organization,
        loading: false,
      };
    case GET_ORGANIZATION_FAILED:
      return { ...state, loading: false, error };
    case UPDATE_ORGANIZATION_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ORGANIZATION_SUCCESS:
    case GENERATE_API_TOKEN_SUCCESS:
    case GENERATE_QC_TOKEN_SUCCESS:
    case GENERATE_REPORTS_API_TOKEN_SUCCESS:
      return {
        ...state,
        organization,
        loading: false,
      };
    case UPDATE_ORGANIZATION_FAILED:
      return {
        ...state, loading: false, error, organization: { ...state.organization },
      };
    default:
      return state;
  }
};

export default organizationsEditReducer;
